/*=========================================================================================
  File Name: moduleCalendarState.js
  Description: Calendar Module State
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

export default {
  reporteCasosByProject: [],
  meta: [
    {title: 'PROYECTO', sortKey: 'vaa'},
    {title: 'DISTRIBUIDORA', sortKey:'vao'},
    {title: 'NUM_CASO', sortKey: 'vab'},
    {title: 'DESC_CASO', sortKey: 'vac'},
    {title: 'RESPONSABLE', sortKey: 'vad'},
    {title:'REGISTRA', sortKey:'vae'},
    {title:'GRUPO_TIPO_CASO', sortKey:'vaao'},
    {title:'TIPO_CASO', sortKey:'vag'},
    {title:'APLICATIVO', sortKey:'vaaa'},
    {title:'NIVEL', sortKey:'vah'},
    {title:'ESTADO', sortKey:'vai'},
    {title:'FECHA_REGISTRO', sortKey:'vaj'},
    {title:'HORA_REGISTRO', sortKey:'vajHour'},

    {title:'AÑO', sortKey:'vaak'},
    {title:'MES', sortKey:'vaal'},

    {title: 'FECHA_CIERRE', sortKey: 'vak'},
    {title: 'HORA_CIERRE', sortKey: 'vakHour'},
    {title: 'FECHA_COMPROMISO', sortKey: 'val'},
    {title: 'OBSERVACION', sortKey:'van'},
    {title: 'VENCIDO', sortKey:'vaq'},
    {title:'CODIGO_CASO_EXTERNO', sortKey:'vaam'},
    {title:'CUENTA', sortKey:'vaan'},
    {title:'FUENTE', sortKey:'vaai'}



    // {title: 'ACCIONES', sortKey: ''}
  ]


}
